module.exports = __webpack_public_path__ + "static/media/PATINEX_serviceblow3_eng.83ff2371.png";